import React from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import DocumentTitle from 'react-document-title'
import Header from './Header'

export default function MasterPage() {
  const location = useLocation()

  return (
    <DocumentTitle title={'Café App'}>
      <div className='MasterPage'>
        <Header location={location}/>
        <Outlet />
      </div>
    </DocumentTitle>
  )
}
